<div class="modal-header" style="border-radius: none" *ngIf="header">
  <div class="row w-100 pl-3 p-0">
    <div class="col-10 p-0">
      <h3 class="m-0">{{ "feed.feed-selected" | translate }}:</h3>
      <input
        class="p-0"
        [value]="textPonds(DataPonds)"
        placeholder="{{ 'plantings.modal.no-selected-ponds' | translate }}"
        class="w-100"
        style="border: none; background-color: transparent; color: var(--primary) ''"
        disabled
      />
      <p>{{ "feed.larva-amount" | translate }}.</p>
    </div>
    <div class="col-2 p-0 d-flex justify-content-center align-items-end" style="z-index: 1">
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closedClick()"
        style="font-size: 34px; padding: 23px"
        *ngIf="ButtonClosed"
      >
        <span aria-hidden="true" class="text-danger">&times;</span>
      </button>
    </div>
  </div>
</div>
<!-- <div class="alert-section" *ngIf="validateButtonDisabled()">
  <div class="flex-column text-center">
    Tienes que sembrar para poder alimentar
    <button
      class="btn btn-dark ml-3"
      (click)="goPlanting('')"
      *ngIf="permissions.change_plantings"
    >
      Modulo de siembra
    </button>
  </div>
</div> -->

<!-- [ngClass]="{ 'disabled-section': validateButtonDisabled() }" -->
<div [ngClass]="{ 'pb-0': header }">
  <div class="row mx-0 mb-5">
    <div class="col-12 p-0 flex-column card-template p-3" style="border-radius: 0">
      <b>{{ "feed-component.ration-shipment" | translate }}</b>
      <nav class="tabs">
        <a
          class="tab-item"
          [class.active]="!manual && !is_maintenance"
          (click)="is_maintenance = false; manual = false"
        >
          {{ "speed-config.normal" | translate }}
        </a>

        <a
          class="tab-item"
          [class.active]="!manual && is_maintenance"
          (click)="is_maintenance = true; manual = false"
        >
          {{ "alerts.actions.maintenance" | translate }}
        </a>

        <a class="tab-item" [class.active]="manual" (click)="changeManual()">
          {{ "feed-component.manual" | translate }}
        </a>
      </nav>
    </div>
    <div class="p-4" *ngIf="loading_feed.view || !feedReady">
      <app-loading-time
        [type]="2"
        [url]="loading_feed.url"
        [petition]="loading_feed.view"
      ></app-loading-time>
    </div>
    <ng-container *ngIf="!loading_feed.view && feedReady">
      <div class="col-12 mt-1 p-3">
        <div class="row">
          <div class="col-12 p-2" *ngIf="manual">
            <ng-container>
              <input
                type="date"
                class="form-control"
                [(ngModel)]="manualDate"
                name="manualDate"
                id="manualDate"
              />
              <span>{{ "feed-component.feeding-date" | translate }}</span>
            </ng-container>
          </div>
          <div class="col-12">
            <form class="row" [formGroup]="FeedForm">
              <ng-container *ngIf="DataPonds.length === 1">
                <div class="col-6 p-2">
                  <input
                    autofocus
                    formControlName="kg"
                    [(ngModel)]="kgPond"
                    step="0.01"
                    (change)="calculateKgHA(DataPonds, 1)"
                    (keypress)="decimalFilter($event)"
                    class="form-control"
                    placeholder="kg"
                    type="search"
                    (keyup)="checkKey($event)"
                    id="kgPond"
                  />
                  <span>{{ "feed.pond-kg" | translate }}</span>
                </div>
                <div class="col-6 p-2">
                  <input
                    [(ngModel)]="kgHec"
                    step="0.01"
                    (change)="calculateKgHA(DataPonds, 2)"
                    (keypress)="decimalFilter($event)"
                    [ngModelOptions]="{ standalone: true }"
                    type="search"
                    class="form-control"
                    placeholder="kg"
                    (keyup)="checkKey($event)"
                    id="kgHec"
                  />
                  <span>{{ "feed.hectare-kg" | translate }}</span>
                </div>
              </ng-container>
              <ng-container *ngIf="DataPonds.length > 1">
                <div class="col-6 p-2">
                  <input
                    formControlName="kg"
                    type="number"
                    class="form-control"
                    placeholder="kg"
                    id="kg_feed"
                    (keyup)="checkKey($event)"
                  />
                  <span>{{ "feed.pond-kg" | translate }}</span>
                </div>
                <div class="col-6 p-2" id="kgHec">
                  <b>{{ validatePonds(FeedForm.value.kg, DataPonds) }}</b>
                  <span>{{ "feed.hectare-kg" | translate }}</span>
                </div>
              </ng-container>
              <div class="col-12 p-2" *ngIf="!manual">
                <div class="d-flex gap-6">
                  <select
                    formControlName="diet"
                    class="form-control"
                    id="diet_feed"
                    (keyup)="checkKey($event)"
                    *ngIf="canSendRation()"
                  >
                    <option value="">
                      {{ "feed.select-diet" | translate }}
                    </option>
                    <option *ngFor="let item of diets" [value]="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                  <select class="form-control" *ngIf="!canSendRation()" disabled>
                    <option value="" selected>
                      {{ "feed.admin-diet" | translate }}
                    </option>
                  </select>
                  <ng-container *ngIf="canSendRation()">
                    <button
                      class="btn btn-secondary"
                      (click)="setData()"
                      style="padding: 5px 12px 10px 12px"
                    >
                      <img src="assets/menu-icons/parametrias.svg" alt="diet" width="20" />
                    </button>
                  </ng-container>
                </div>
                <span>{{ "feed.diets" | translate }}</span>
              </div>

              <div class="col-12 p-2">
                <div class="d-flex gap-6">
                  <select
                    formControlName="food"
                    class="form-control"
                    id="food_feed"
                    (keyup)="checkKey($event)"
                    (change)="select_food(FeedForm.value.food)"
                  >
                    <option value="">
                      {{ "feed.select-food" | translate }}
                    </option>
                    <option *ngFor="let item of foods" [value]="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                  <div
                    class="d-flex flex-column text-center"
                    *ngIf="food_selected && food_selected.protein"
                  >
                    <p class="m-0">{{ "feed-component.protein" | translate }}</p>
                    <small class="m-0">{{ food_selected.protein | percent }}</small>
                  </div>
                </div>
                <span>{{ "ration-modal.food" | translate }}</span>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        class="col-12 d-flex justify-content-center align-items-center flex-column mt-3"
        *ngIf="permissions.change_feed"
      >
        <!-- El envio manual (kg + alimento) se permite aun en estanques manejados por
             administracion (feeding_by_admin): solo la dieta preestablecida queda
             bloqueada para el cliente en ese caso (ver select de dieta arriba) -->

        <button
          class="btn btn-success btn-space"
          type="button"
          [disabled]="FeedForm.invalid || loadingFeeder"
          id="send_feed"
          (click)="register()"
        >
          <div *ngIf="loadingFeeder" class="spinner-border spinner-border-sm mr-1" role="status">
            <span class="sr-only"></span>
          </div>
          {{ "feed-component.send-ration" | translate }}
        </button>

        <div class="d-flex gap-10 align-items-center mt-2" *ngIf="!manual">
          <label class="form-check-label" for="input_response">
            <p class="m-0">{{ "feed-component.show-responses-on-send" | translate }}</p>
          </label>
          <label class="switch m-0">
            <input type="checkbox" id="input_response" [(ngModel)]="view_response" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<app-test-feed
  *ngIf="view_response && submit_response"
  [view]="submit_response"
  [status_server]="status_server"
  [ponds]="DataPonds"
  (closed)="closedTest($event)"
  (feed)="register()"
  (refeed)="refeed()"
  [mode]="mode_test"
></app-test-feed>

<ng-template #modalSiembra>
  <div class="modal-content">
    <div class="text-rigth">
      <button
        class="text-danger"
        type="button"
        class="close"
        aria-label="Close"
        (click)="Modal(test, 'hide')"
        style="font-size: 25px; position: absolute; right: 17px; top: 6px"
      >
        <span aria-hidden="true" style="font-size: 20px; color: white">&times;</span>
      </button>
    </div>

    <app-plantings
      *ngIf="type === ''"
      [DataPonds]="DataPonds"
      [idPlanting]="plantingSelected ? plantingSelected.id : ''"
      [type]="type"
      (closed)="submitHarvests($event)"
    >
    </app-plantings>
    <app-extended-harvest
      *ngIf="type !== ''"
      [current_alert]="refresh_value"
      [sowData]="DataPonds.length > 0 ? DataPonds[0].planting : null"
      [type]="type === 'cosecha' ? 4 : validateAliasDate()"
    >
    </app-extended-harvest>
  </div>
</ng-template>

<ng-template #modalDiet>
  <div class="modal-header d-flex bg-primary p-2 align-items-center text-center">
    <div class="d-flex align-items-center flex-wrap p-2 border-header">
      <div class="d-none d-lg-flex align-items-center mr-2">
        <app-image-color
          [height]="'30px'"
          [width]="'40px'"
          [url]="'menu-icons/diets.svg'"
          [color]="'#ffffff'"
        ></app-image-color>
      </div>
      <div class="line bg-white d-none d-lg-flex"></div>
      <div class="text-left ml-2">
        <div class="flex-column">
          <h2 class="mb-0 d-flex align-items-start">
            {{ "clients.diet.diet-graph" | translate }} - {{ selectedDietName }}
          </h2>
          <p class="m-0">{{ "clients.diet.graph-view" | translate }}</p>
        </div>
      </div>
    </div>
    <h3 class="m-0 c-pointer" (click)="Modal(modal, 'hide')">&times;</h3>
  </div>

  <div class="mt-2">
    <ng-container *ngIf="validatingAdmin(); else noAdmin">
      <app-echar
        [type]="'diet'"
        [labels]="labelsGraph"
        [data]="dataGraph"
        [options]="optionsGraph"
        [height]="500"
        [heightStyle]="'px'"
      ></app-echar>
    </ng-container>
    <ng-template #noAdmin>
      <div class="center flex-column p-4">
        <p>{{ "clients.diet.no-access" | translate }}</p>
      </div>
    </ng-template>
  </div>
</ng-template>
